<template>
  <div
    v-if="!hideHeader"
    class="ui-dropper"
    >
    <div
      data-slot="head"
      :data-open="model"
      class="items-center border-b py-2 hover:bg-gray-100 cursor-pointer content-center w-full flex"
      :class="headClasses"
      @click="methodToggleSlot"
      >
      <i v-if="chevronLeft && !model" class="fas fa-angle-down px-2"/>
      <i v-if="chevronLeft && model" class="fas fa-angle-up px-2"/>

      <slot
        name="head"
        @click="methodToggleSlot">
        {{ text }}
      </slot>

      <i v-if="chevronRight && !model" class="inline-block ml-auto self-center h-auto fas fa-angle-down px-2"/>
      <i v-if="chevronRight && model" class="inline-block ml-auto self-center h-auto fas fa-angle-up px-2"/>
    </div>
    <div v-show="model" data-slot="default">
      <slot />
    </div>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
const emit = defineEmits(['toggled', 'closed', 'opened'])
const props = defineProps<{
  chevronLeft?: boolean
  chevronRight?: boolean
  headClasses?: any
  hideHeader?: boolean
  startOpen?: boolean
  text?: string
  preventOpen?: boolean
}>()

const model = defineModel<boolean>({
  default: false,
})

onMounted(() => {
  if (props.startOpen) {
    model.value = true
  }
})

const methodToggleSlot = () => {
  if(props.preventOpen) return;
  model.value = !model.value
}

watch(model, (value) => {
  if(value){
    emit('opened', true)
    emit('toggled', true)
  }else{
    emit('closed', true)
    emit('toggled', false)
  }
})

defineExpose({
  close: () => model.value = false,
  open: () => model.value = true,
  toggle: () => model.value = !model.value,
})
</script>
